import React from 'react';
import ResourceList from './resource-list';

const ProjectList = (props) => (
    <ResourceList {...props} fields={['title', 'organization.name']} labels={['Title', 'Organization']} path="/projects/" />
);

export default ProjectList;